import { Schemas } from '~/api/gen'
import { MetaData } from '~/components/Meta'
import { getUserNameForSeo } from '~/lib/seo'

type Member = Pick<
  Schemas.member_large_detail,
  | 'user_name'
  | 'id'
  | 'image'
  | 'is_wearista'
  | 'is_shop_clerk'
  | 'shop'
  | 'nick_name'
>

export const getMetadata = (member: Member, followCount: number): MetaData => {
  const name = getUserNameForSeo({
    nickname: member.nick_name,
    wearista: member.is_wearista,
    shopClerk: member.is_shop_clerk,
    shopName: member.shop?.name,
  })
  return {
    title: `${name}のフォロー一覧`,
    description:
      followCount > 0
        ? `${name}がフォローしているユーザ一覧です。${name}がチェックしているユーザーから、趣味の近いおしゃれなコーディネートを見つけましょう！`
        : `${name}がフォローしているユーザ一覧です。WEARはモデル・俳優・ショップスタッフなどの着こなしをチェックできるファッションコーディネートサイトです。`,
    url: `https://wear.jp/${member.user_name}/follow/`,
    appUrl: `wear2020://wear.jp/user/${member.id}/`,
    ogImageUrl: member.image.url_640 ?? undefined,
    robots: false,
  }
}
